import { createClient } from '@supabase/supabase-js';

if (typeof window !== 'undefined' && (window.location.href.includes('type=recovery') || window.location.hash.includes('type=recovery'))) {
  document.cookie = "xfolyo_recovery_lock=true; path=/; max-age=3600;";
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// ── Helper: รับประกัน session พร้อมก่อนทำ request ────────────
export const ensureFreshSession = async () => {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.warn('Session refresh check failed:', error.message);
      return false;
    }
    const session = data?.session;
    if (!session) return false;

    const now = Math.floor(Date.now() / 1000);
    if (session.expires_at && session.expires_at - now < 60) {
      const { error: refreshError } = await supabase.auth.refreshSession();
      if (refreshError) {
        console.warn('Session refresh failed:', refreshError.message);
        return false;
      }
    }
    return true;
  } catch (e) {
    console.warn('ensureFreshSession error:', e);
    return false;
  }
};

// ── Helper: wrap supabase call ให้ retry อัตโนมัติถ้า session หมด ──
export const withSessionRetry = async (fn) => {
  try {
    const result = await fn();

    // ถ้า error เป็นเรื่อง auth ให้ refresh แล้ว retry 1 ครั้ง
    if (result?.error?.status === 401 || result?.error?.message?.includes('JWT')) {
      console.warn('Session expired, refreshing and retrying...');
      const refreshed = await ensureFreshSession();
      if (refreshed) return await fn();
    }

    return result;
  } catch (e) {
    console.warn('withSessionRetry error:', e);
    throw e;
  }
};

if (typeof window !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      ensureFreshSession();
      supabase.auth.startAutoRefresh();
    } else {
      supabase.auth.stopAutoRefresh();
    }
  });

  window.addEventListener('focus', ensureFreshSession);
}

export const withTimeout = (promise, ms = 15000) => {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error("TIMEOUT")), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
};